import { ApolloError, ApolloLink, isApolloError } from '@apollo/client'

export const userErrorLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((fetchResult) => {
    for (const result of Object.values(fetchResult.data ?? {})) {
      const { userError } = result ?? {}
      if (userError) {
        throw new ApolloError({
          errorMessage: userError.message,
          extraInfo: { userError },
        })
      }
    }
    return fetchResult
  })
})

/**
 * True when the failure is a business rule the customer can act on (a rejected start date, a bad campaign code),
 * as opposed to a transport or server fault that is ours to fix and worth logging as an error.
 */
export const isUserError = (error: unknown): error is ApolloError =>
  error instanceof Error && isApolloError(error) && error.extraInfo?.userError != null
